const pollData = <ApiReturnType>(apiCall: () => Promise<ApiReturnType>, shouldRefetch: (input: ApiReturnType) => boolean, beforeEachRetry: (input: ApiReturnType) => void, afterFinishedRetrying?: (input: ApiReturnType) => void, onError?: (error: unknown) => void) => {
  const handleError = (error: unknown) => {
    if (onError) {
      onError(error);
    }
  };

  const recursiveCallback = (data: ApiReturnType) => {
    beforeEachRetry(data);
    if (shouldRefetch(data)) {
      setTimeout(() => {
        // Detached timeout: catch the rejection or it's lost and the toast spins forever.
        apiCall()
          .then(recursiveCallback)
          .catch(handleError);
      }, 5000);
    } else {
      if (afterFinishedRetrying) {
        afterFinishedRetrying(data);
      }
    }
    return data;
  };

  return apiCall().then(recursiveCallback).catch(handleError);
};

export default pollData;
